import { TreeAccordion } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import styles from "./ExpandCollapseNode.module.less";

export type ExpandCollapseNodeProps = {
	isExpanded: boolean;
	onIsExpandedChange: (value: boolean) => void;
	trackingId: string;
};

export const ExpandCollapseNode = (props: ExpandCollapseNodeProps): ReactElement => {
	const {
		isExpanded,
		onIsExpandedChange,
		trackingId
	} = props;

	return (
		<TreeAccordion.Node>
			<TreeAccordion.Item
				isSelected={false}
				onClick={() => onIsExpandedChange(!isExpanded)}
				indentionLevel={1}
				trackingId={trackingId}
			>
				<span className={styles.expandItemText}>
					{isExpanded ? localize("_ShowLess") : localize("_ShowMore")}
				</span>
			</TreeAccordion.Item>
		</TreeAccordion.Node>
	);
};
ExpandCollapseNode.displayName = "ExpandCollapseNode";
